/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Eventvisibilitylabel2Inputs */

const en_eventvisibilitylabel2 = /** @type {(inputs: Eventvisibilitylabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Visibility`)
};

const de_eventvisibilitylabel2 = /** @type {(inputs: Eventvisibilitylabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sichtbarkeit`)
};

/**
* | output |
* | --- |
* | "Visibility" |
*
* @param {Eventvisibilitylabel2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const eventvisibilitylabel2 = /** @type {((inputs?: Eventvisibilitylabel2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Eventvisibilitylabel2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_eventvisibilitylabel2(inputs)
	return de_eventvisibilitylabel2(inputs)
});
export { eventvisibilitylabel2 as "eventVisibilityLabel" }